/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Gate_InvalidInputs */

const en_error_gate_invalid = /** @type {(inputs: Error_Gate_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The gate cannot be saved as it is: correct the field marked.`)
};

/**
* | output |
* | --- |
* | "The gate cannot be saved as it is: correct the field marked." |
*
* @param {Error_Gate_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_gate_invalid = /** @type {((inputs?: Error_Gate_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Gate_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_gate_invalid(inputs)
});